// eslint-disable-next-line
/* eslint-disable */


import { method } from 'lodash'
import { api, apiTest, apiIA } from './config'
import request from './request'

export default {
    recepcionista: {
        retornarPacienteAFila(idAtendimento, idUnidade, codigo, servico) {
            var obj = {
                idAtendimento: idAtendimento,
                idUnidade: idUnidade,
                codigo: codigo,
                servico: servico
            }
            return request({
                url: '/recepcionista/retornarPacienteAFila/',
                method: 'post',
                data: obj
            })
        },

        retornarAtendimentos() {
            return request({
                url: '/recepcionista/retornarAtendimentos/',
                method: 'get'
            })
        },

        fazerChamada(idAtendimento, codigo, codigoSigla, guiche, prioridade) {

            var obj = {
                    idAtendimento: idAtendimento,
                    codigo: codigo,
                    codigoSigla: codigoSigla,
                    guiche: guiche,
                    prioridade: prioridade,
                }
                //return api.post('/recepcionista/fazerChamada',obj)  
            return request({
                url: '/recepcionista/fazerChamada/',
                method: 'post',
                data: obj
            })

        },

        chamadaNaoAtendida(idAtendimento, codigo, nomeEspecialidade, idServico, prioridade, servicos) {
            var obj = {
                    idAtendimento: idAtendimento,
                    codigo: codigo,
                    nomeEspecialidade: nomeEspecialidade,
                    idServico,
                    prioridade,
                    servicos: servicos
                }
                //return api.post('/recepcionista/chamadaNaoAtendida',obj)
            return request({
                url: '/recepcionista/chamadaNaoAtendida/',
                method: 'post',
                data: obj
            })
        },

        iniciarAtendimento(codigo, idAtendimento) {
            var obj = {
                codigo: codigo,
                idAtendimento
            }
            return request({
                url: '/recepcionista/iniciarAtendimento/',
                method: 'post',
                data: obj
            })
        },

        encerrarAtendimento(idAtendimento, codigo, prioridade,
            nomePaciente, numeroPaciente, idPaciente, idExamesos, idMedico,
            consultas, dataNascimento) {
            console.log('em servico', idMedico);

            var obj = {
                codigo: codigo,
                idAtendimento: idAtendimento,
                nomePaciente: nomePaciente,
                numeroPaciente: numeroPaciente,
                idPaciente: idPaciente,
                idExamesos: idExamesos,
                prioridade: prioridade,
                consultas: consultas,
                dataNascimento: dataNascimento,
            }
            console.log('encerrou atendimento', obj)

            return request({
                url: '/recepcionista/encerrarAtendimento/',
                method: 'post',
                data: obj
            })
        },

        encerrarAtendimentoExameNaoEncontrado(idAtendimento, idOrdemServico, nomePaciente,
            numeroPaciente, idPaciente, idExamesos) {

            var obj = {
                idAtendimento: idAtendimento,
                idOrdemServico: idOrdemServico,
                nomePaciente: nomePaciente,
                numeroPaciente: numeroPaciente,
                idPaciente: idPaciente,
                idExamesos: idExamesos,
            }

            return request({
                url: '/recepcionista/encerrarAtendimentoExameNaoEncontrado/',
                method: 'post',
                data: obj
            })
        },

        adicionarOrdemDeServico(ordemServico, idAtendimento, servicos) {
            console.log('servicos antes de enviar', servicos);

            var obj = {
                ordemServico: ordemServico,
                idAtendimento: idAtendimento,
                servicos: servicos,
            }

            return request({
                url: '/recepcionista/adicionarOrdemServico/',
                method: 'post',
                data: obj
            })
        },

        retornarServicosUsuarioOs(os) {
            //return api.get(`/simplesMedic/retornarExamesOs/${os}`)
            //servicos
            return request({
                url: `/recepcionista/retornarServicosUsuarioOs/${os}`,
                method: 'get'
            })
        },

        retornarMedicosOs(os) {
            //return api.get(`/simplesMedic/retornarExamesOs/${os}`)
            //servicos
            return request({
                url: `/recepcionista/retornarMedicosOs/${os}`,
                method: 'get'
            })
        },

        retornarUsuarioOs(os) {
            //return api.get(`/simplesMedic/retornarExamesOs/${os}`)
            //servicos
            return request({
                url: `/recepcionista/retornarUsuarioOs/${os}`,
                method: 'get'
            })
        },

        retornarMedicos() { //NAO VAI USAR !!!
            // console.log(id);            
            // return api.get('/recepcionista/retornarMedicos/'+id)
            return request({
                url: '/recepcionista/retornarMedicos/',
                method: 'get'
            })
        },

        retornarPrioridade() {
            //return api.get('/recepcionista/retornarPrioridade/'+idLocal)
            return request({
                url: '/recepcionista/retornarPrioridade/',
                method: 'get'
            })
        },

        alterarLocal(idLocal) {
            var obj = {
                idLocal: idLocal,
            }
            return request({
                url: '/recepcionista/alterarLocal/',
                method: 'post',
                data: obj
            })
        },
        retornarLocais() {
            // console.log(id);
            // return api.get('administradorUnidade/retornarLocais')

            return request({
                url: '/recepcionista/retornarLocais/',
                method: 'get'
            })
        },

        refreshToken(token) {
            // metodo do visor..  
            //return api.post('/atendente/retornarChamadas',obj)
            return request({
                url: 'recepcionista/refreshToken',
                method: 'post',
                data: token
            })
        },
        cancelarAtendimento(idAtendimento) {
            // metodo do visor..  
            //return api.post('/atendente/retornarChamadas',obj)
            var obj = {
                idAtendimento: idAtendimento,
            }
            return request({
                url: 'recepcionista/cancelarAtendimento',
                method: 'post',
                data: obj
            })
        },
         // exame
        retornarInfoOS (os) {
            return request({
            url: `recepcionista/retornarInfoOS/${os}`,
            method: 'get'
            })
        },
        retornarInfoSenhas () {
            return request({
            url: `recepcionista/retornarInfoSenhas`,
            method: 'get'
            })
        },
        retornarServicos(idLocal) {
            // metodo do recep.. 
            return request({
                url: `/recepcionista/retornarServicos/${idLocal}`,
                method: 'get',
            })
        },

        retornarQuantConsultas(idLocal) {
            return request({
                url: `/recepcionista/retornarQuantConsultas/${idLocal}`,
                method: 'get'
            })
        },

        retornarHelp(tipo) {
            return request({
                url: `/recepcionista/retornarHelp/${tipo}`,
                method: 'get'
            })
        },

        transferirAtendimento(idAtendimento, idServico, codigo, prioridade, nomeEspecialidade) {
            var obj = {
                idAtendimento: idAtendimento,
                idServico: idServico,
                codigo: codigo,
                prioridade: prioridade,
                nomeEspecialidade: nomeEspecialidade
            }
            return request({
                url: 'recepcionista/transferirAtendimento',
                method: 'post',
                data: obj
            })
        },
        retornarMedicosExame(idExame) {
            return request({
                url: `recepcionista/retornarMedicosExame/${idExame}`,
                method: 'get'
            })
        },
        alterarMedicoConsulta(idAtendimento, idConsulta, idMedico) {
            var data = {
                idAtendimento: idAtendimento,
                idConsulta: idConsulta,
                idMedico: idMedico
            }
            return request({
                url: `recepcionista/alterarMedicoConsulta`,
                method: 'post',
                data: data
            })
        },
        processarnew (idos) {
            return apiIA.post(`/api/resumo/processarnew?idos=${idos}`)
        },
        processarResumoClinico(idPaciente) {

            return apiIA.post(`/api/resumo/processar?idPaciente=${idPaciente}`)
        }
    }
}